/**
 * Get the current location of the user
 *
 * @returns {Promise}
 */
export default async function getLocation() {
  return new Promise((res, rej) => {
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;

      res({
        latitude,
        longitude
      });
    }, (error) => {
      rej(new Error(`${error.code} ${error.message}`))
    }, { enableHighAccuracy: true });
  });
}
